import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-nav-top',
  templateUrl: './nav-top.component.html',
  styleUrl: './nav-top.component.css'
})
export class NavTopComponent implements OnInit, AfterViewInit{
  @Input() title: string = '';
  @Input() quantityCart: number = 0;
  @Output() action = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  constructor(private location: Location) { }


  ngOnInit(): void {
    
  }
  ngAfterViewInit(): void {
    
  }

  goback(){
    this.back.emit();
  }

  actionClick(){
    this.action.emit();
  }
}
